import { instance } from "./apiBase";

export interface CapabilityTokenResponse {
  identity: string;
  token: string;
  expires_at: string;
}

export interface CallSummary {
  id: number;
  status:
    | "authorized"
    | "queued"
    | "ringing"
    | "in_progress"
    | "completed"
    | "failed"
    | "no_answer"
    | "busy"
    | "canceled"
    | "expired_before_dial";
  version: number;
  direction: "outbound" | "inbound";
  from_number: string;
  to_number: string;
  lead_id: number | null;
  customer_id: number | null;
  duration_seconds: number | null;
  disposition: string | null;
  recording_url: string | null;
  started_at: string | null;
  answered_at: string | null;
  ended_at: string | null;
  authorized_expires_at: string;
  created_at: string;
}

export interface AuthorizeCallPayload {
  to_number: string;
  idempotency_key: string;
  lead_id?: number;
  customer_id?: number;
  // Caller-selected "from" number; omitted -> backend picks the default.
  provisioned_phone_number_id?: number;
}

export interface AuthorizeCallResponse {
  call: CallSummary;
  dial_token: string;
}

export interface RecordingResponse {
  recording_url: string;
  duration_seconds: number | null;
}

export interface AnnounceCallPayload {
  to_number: string;
  message: string;
  lead_id?: number;
  customer_id?: number;
}

export const voiceApi = {
  async getCapabilityToken(): Promise<CapabilityTokenResponse> {
    const { data } = await instance.get<CapabilityTokenResponse>(
      "/portal/v1/boom_crm/voice/capability_token"
    );
    return data;
  },

  async authorizeCall(
    payload: AuthorizeCallPayload
  ): Promise<AuthorizeCallResponse> {
    const { data } = await instance.post<AuthorizeCallResponse>(
      "/portal/v1/boom_crm/calls",
      payload
    );
    return data;
  },

  async fetchCall(id: number): Promise<CallSummary> {
    const { data } = await instance.get<CallSummary>(
      `/portal/v1/boom_crm/calls/${id}`
    );
    return data;
  },

  async submitDisposition(
    id: number,
    disposition: string
  ): Promise<CallSummary> {
    const { data } = await instance.patch<CallSummary>(
      `/portal/v1/boom_crm/calls/${id}`,
      { disposition }
    );
    return data;
  },

  async getRecording(id: string): Promise<RecordingResponse> {
    const { data } = await instance.get<RecordingResponse>(
      `/portal/v1/boom_crm/calls/${id}/recording`
    );
    return data;
  },

  async announce(payload: AnnounceCallPayload): Promise<CallSummary> {
    const { data } = await instance.post<CallSummary>(
      "/portal/v1/boom_crm/calls/announce",
      payload
    );
    return data;
  }
};
